import geocoder from '../../geocoder';

function isPlaceStreetAddress(result) {
  return result && (
    result.types.indexOf('premise') >= 0 ||
    result.types.indexOf('street_address') >= 0);
}

function convertPlaceToAddress(result) {
  let address = {
    id: result.place_id,
    label: result.formatted_address,
    latlng: result.geometry.location.toJSON(),
  };
  result.address_components.forEach(component => {
    if (component.types.indexOf('street_number') >= 0) {
      address.streetNumber = component.long_name;
    } else if (component.types.indexOf('route') >= 0) {
      address.street = component.long_name;
      address.streetAbbrev = component.short_name;
    } else if (component.types.indexOf('locality') >= 0) {
      address.city = component.long_name;
    } else if (component.types.indexOf('administrative_area_level_1') >= 0) {
      address.state = component.long_name;
      address.stateCode = component.short_name;
    } else if (component.types.indexOf('postal_code') >= 0) {
      address.zipCode = component.short_name;
    }
  });
  if (address.streetNumber && address.street) {
    return address;
  } else {
    return null;
  }
}

export class GoogleMapsGeocoder {
  async geocodeCity(query) {
    return geocoder().then(gc => {
      return new Promise((resolve) => {
        gc.geocode({
          address: query,
          componentRestrictions: {
            country: 'US'
          }
        }, (results) => {
          resolve(Promise.all(results.map(async result => {
            if (result.types.indexOf('locality') < 0) {
              return null;
            }
            let latlng = result.geometry.location.toJSON();
            let name = result.address_components
              .filter(ac => ac.types.indexOf('locality') >= 0)
              .map(ac => ac.long_name)[0];
            let state = result.address_components
              .filter(ac => ac.types.indexOf('administrative_area_level_1') >= 0)
              .map(ac => ac.short_name)[0];
            let placeId = result.place_id;
            return { name, state, latlng, placeId };
          }).filter(city => !!city)));
        });
      });
    });
  }

  async geocodeAddress(address, { state, locality } = {}) {
    return geocoder().then(gc => {

      return new Promise((resolve, reject) => {
        gc.geocode({
          address: address,
          componentRestrictions: {
            country: 'US',
            administrativeArea: state,
            locality
          }
        }, (results, status) => {


          if (status !== 'OK') {
            reject(status);
          } else {
            const addresses = results.filter(isPlaceStreetAddress);
            resolve(addresses.map(convertPlaceToAddress));
          }
        });
      });
    });
  }
}

export { isPlaceStreetAddress, convertPlaceToAddress };
